import { addScript } from '@tunein/web-utils';
import { GoogleIMAProvider } from '../GoogleIMAProvider';
const ADSWIZZ_SYNCHROBOX_SCRIPT = 'https://synchrobox.adswizz.com/register2.php';
const ADSWIZZ_SYNCHROCLIENT_SCRIPT = 'https://delivery-cdn-cf.adswizz.com/adswizz/js/SynchroClient2.js';
const ADSWIZZ_SYNCHROBOX_SCRIPT_ID = 'ADSWIZZ_SYNCHROBOX_SCRIPT';
const ADSWIZZ_SYNCHROCLIENT_SCRIPT_ID = 'ADSWIZZ_SYNCHROCLIENT_SCRIPT';
export class AdsWizzProvider extends GoogleIMAProvider {
    static #readyPromise = Promise.withResolvers();
    static #initStarted = false;
    static get ready() {
        return AdsWizzProvider.#readyPromise.promise;
    }
    static async init(privacyData) {
        if (AdsWizzProvider.#initStarted) {
            return AdsWizzProvider.#readyPromise.promise;
        }
        AdsWizzProvider.#initStarted = true;
        const { usPrivacyString, gdprApplies, gdprTcString } = privacyData || {};
        const synchroBoxUrl = new URL(ADSWIZZ_SYNCHROBOX_SCRIPT);
        const synchroClientUrl = new URL(ADSWIZZ_SYNCHROCLIENT_SCRIPT);
        if (usPrivacyString) {
            synchroBoxUrl.searchParams.set('us_privacy', usPrivacyString);
            synchroClientUrl.searchParams.set('us_privacy', usPrivacyString);
        }
        if (gdprApplies && gdprTcString) {
            synchroBoxUrl.searchParams.set('aw_0_req.userConsentV2', gdprTcString);
            synchroClientUrl.searchParams.set('aw_0_req.userConsentV2', gdprTcString);
        }
        try {
            await Promise.all([
                GoogleIMAProvider.init(),
                addScript({
                    src: synchroBoxUrl.toString(),
                    id: ADSWIZZ_SYNCHROBOX_SCRIPT_ID,
                    async: false,
                }),
                addScript({
                    src: synchroClientUrl.toString(),
                    id: ADSWIZZ_SYNCHROCLIENT_SCRIPT_ID,
                    async: false,
                }),
            ]);
            AdsWizzProvider.#readyPromise.resolve();
        }
        catch {
            AdsWizzProvider.#readyPromise.reject(new Error('AdsWizz scripts loading failed'));
        }
        return AdsWizzProvider.#readyPromise.promise;
    }
    get name() {
        return 'adswizz';
    }
}
